import { render, staticRenderFns } from "./complianceVideoUpload.vue?vue&type=template&id=4b74f05a&"
import script from "./complianceVideoUpload.vue?vue&type=script&lang=js&"
export * from "./complianceVideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./complianceVideoUpload.vue?vue&type=style&index=0&id=4b74f05a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports